/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_mailbox",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "nonce",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint64",
                name: "portalSequence",
                type: "uint64",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "destination",
                type: "uint32",
            },
        ],
        name: "BridgedToken",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint32",
                name: "hyperlaneDomain",
                type: "uint32",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "wormholeDomain",
                type: "uint32",
            },
        ],
        name: "DomainAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_hook",
                type: "address",
            },
        ],
        name: "HookSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_ism",
                type: "address",
            },
        ],
        name: "IsmSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        inputs: [],
        name: "PACKAGE_VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_hyperlaneDomain",
                type: "uint32",
            },
            {
                internalType: "uint16",
                name: "_wormholeDomain",
                type: "uint16",
            },
        ],
        name: "addDomain",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVm",
                type: "bytes",
            },
        ],
        name: "completeTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "domains",
        outputs: [
            {
                internalType: "uint32[]",
                name: "",
                type: "uint32[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_domain",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "_router",
                type: "bytes32",
            },
        ],
        name: "enrollRemoteRouter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32[]",
                name: "_domains",
                type: "uint32[]",
            },
            {
                internalType: "bytes32[]",
                name: "_addresses",
                type: "bytes32[]",
            },
        ],
        name: "enrollRemoteRouters",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_origin",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "_sender",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "_message",
                type: "bytes",
            },
        ],
        name: "handle",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "hook",
        outputs: [
            {
                internalType: "contract IPostDispatchHook",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        name: "hyperlaneDomainToWormholeDomain",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "_portalTokenBridge",
                type: "address",
            },
            {
                internalType: "address",
                name: "_liquidityLayerRouter",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "interchainSecurityModule",
        outputs: [
            {
                internalType: "contract IInterchainSecurityModule",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "liquidityLayerRouter",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "localDomain",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "mailbox",
        outputs: [
            {
                internalType: "contract IMailbox",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "nonce",
        outputs: [
            {
                internalType: "uint224",
                name: "",
                type: "uint224",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "portalTokenBridge",
        outputs: [
            {
                internalType: "contract IPortalTokenBridge",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "portalTransfersProcessed",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_originDomain",
                type: "uint32",
            },
            {
                internalType: "address",
                name: "_recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_adapterData",
                type: "bytes",
            },
        ],
        name: "receiveTokens",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_domain",
                type: "uint32",
            },
        ],
        name: "routers",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_destinationDomain",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "sendTokens",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_hook",
                type: "address",
            },
        ],
        name: "setHook",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_module",
                type: "address",
            },
        ],
        name: "setInterchainSecurityModule",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_hyperlaneDomain",
                type: "uint32",
            },
            {
                internalType: "uint224",
                name: "_nonce",
                type: "uint224",
            },
        ],
        name: "transferId",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_domain",
                type: "uint32",
            },
        ],
        name: "unenrollRemoteRouter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32[]",
                name: "_domains",
                type: "uint32[]",
            },
        ],
        name: "unenrollRemoteRouters",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class PortalAdapter__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_mailbox, overrides) {
        return super.deploy(_mailbox, overrides || {});
    }
    getDeployTransaction(_mailbox, overrides) {
        return super.getDeployTransaction(_mailbox, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
//# sourceMappingURL=PortalAdapter__factory.js.map